// small icon button (28px) plus breathing room
export const ACTION_TRACK_WIDTH_PX = 32;

// small icon button (34px) plus the 4px gap beside the QuickBooks select
export const QUICK_BOOKS_ICON_SLOT_PX = 38;

export const COMMON_GRID_CONFIG = {
  display: 'grid',
  gridTemplateColumns: 'repeat(12, 1fr)',
  gridTemplateRows: 'repeat(auto-fill, 52px)',
  gridTemplateAreas: `". . . . . . . . qty rate total action"`,
  alignItems: 'center',
  gap: 2,
  bgcolor: 'background.paper',
  px: 1,
};

export type GridConfigType = typeof COMMON_GRID_CONFIG;

export const EM_DASH = '—';

export const SETTLEMENT_NOTES_MAX_LENGTH = 1000;
